import { from, of } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import _ from 'lodash';

import {
  search
} from './actions';

import {
  filtersToEsQuery
} from './utils';

const DEBOUNCE_TIME = 300;
export const searchProvidersEpic = (action$, state$, { token, teladocApi }) =>
  action$.pipe(
    ofType(search.start.toString()),
    distinctUntilChanged(_.isEqual),
    debounceTime(DEBOUNCE_TIME),
    switchMap(action => {
      const url = `/elastic_search/${window.ESEARCH_PROVIDERS_INDEX}/_search`;
      const query = filtersToEsQuery(action.payload);
      return from(teladocApi.post(url, query, token)).pipe(
        map(response => {
          if (response.status === 200) {
            const { data: { hits } } = response;
            if (hits) {
              const results =
                hits.hits.map(h => _.mapKeys(h._source, (value, key) => _.camelCase(key)));
              return search.success(results);
            } else {
              return search.failure();
            }
          } else {
            return search.failure();
          }
        }),
        catchError(e => of(search.failure(e))));
    }),
    catchError(e => of(search.failure(e))));
